import React, { Component } from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Table } from 'react-bootstrap';
import { Link } from "gatsby";
import favicon from '../images/favicon.ico'

import Layout from '../Frame/Layout';
import { Helmet } from "react-helmet";


class About extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <Layout>
                <Helmet>
                    <title>About - Edge.Poker</title>
                    <meta name="description" content="Learn about what is Edge.poker, why use our poker odds calculator and when to use it." />
                    <meta name="keywords" content="about, why use us, edge poker, poker odds calculator, poker analyzer" />
                    <link rel="canonical" href="https://app.edge.poker/about" />
                    <link rel="icon" href={favicon} />
                    <meta http-equiv="content-language" content="en-us"></meta>
                    <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Roboto&display=swap" onload="this.onload=null;this.rel='stylesheet'"></link>  
                    <script src="/sl.js" type='text/javascript'/>
                </Helmet>
                <Row>
                    <Col xs="0" lg="2"/>
                    <Col xs="12" lg="8">
                        <Row>
                            <Col xs="12" className="mb-4 mt-4 text-center">
                                <h1 className="title">About</h1>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12">
                                <p>
                                    <Link to="/">Edge.Poker</Link> is an online Texas Hold'em <strong>poker odds calculator</strong> and analyzer developed by Stockenja. 
                                    We calculate chances of you holding a winning hand automatically based on just your hand, number of players and the shared cards quickly.
                                    This gives players the ability to make quick good decision during an actual game on your
                                    desktop, tablet or phone.
                                </p>
                                <p> 
                                    Moreover, we believe Edge.poker can train beginners or experienced players to get better at their game.
                                    It uses some interesting mathematics concepts (mainly around probability theory) 
                                    to help poker players make better decisions and improve their game. Some of the mathematics that are used include
                                    Kelly criterion and Monte Carlo simulation.
                                </p>
                            </Col>

                            <Col xs="12" id="why" className="mt-3">
                                <h2 className="mb-3">Why Use Edge.Poker?</h2>
                                <p>
                                    Because Edge.poker is a calculator and analyzer that will give you an edge to achieve
                                    long term profitability in Texas Hold'Em. 
                                    This is achieved by aiding players to place value bets as often as possible. 
                                    We also believe that our online calculator can train players to become better over 
                                    the long run.
                                </p>
                                <p>
                                    Most strategies and sophisticated poker odds calculators or analyzer rely on the concept of
                                    guessing opponents' hands. Mathematically speaking, guessing opponents' hands
                                    relies heavily on individual's skill and it is heavily biased. 
                                    Bias causes highly volatile performance, if not losing a lot of money. Furthermore,
                                    it is impossible to mathematically prove that a heuristic strategy or one's ability
                                    to read another player's hand is profitable in the long term.
                                </p>
                                <p>
                                    Due to our mathematical approach of estimating 
                                    <a href="https://en.wikipedia.org/wiki/Poker_probability" target="_blank" className="inline" rel="noopener noreferrer">
                                        &nbsp;probability
                                    </a>
                                    , the advice given is mathematically guaranteed to produce maximum profitability in the long run.
                                    We use the Kelly Citerion to help players to achieve maximum profitability over the long term.
                                    Please note that you may still lose money in some games.
                                    But, in the long run, you should be profitable.
                                    
                                </p>
                                <p>
                                    Other than that, Edge.poker offer top opponents' hands analysis given the shared cards.
                                    Our post-flop opponents' hands analysis can quickly train you to 
                                    identify what are some of the dangerous opponent hands. This is very helpful
                                    when you are new to the game.
                                </p>
                            </Col>

                            

                            <Col xs="12" id="what" className="mt-3">
                                <h2 className="mb-3">What is Edge.Poker?</h2>

                                <p>
                                    Edge.poker provides the following features:
                                </p>

                                <ol>
                                    <li>
                                        <strong>Your winning odds based on only known cards.</strong> 
                                        Edge.poker provides a free version of the calculator that assumes no player fold in Texas Hold'em.
                                        If you want to use hand-range to estimate winning chances, consider signing up for our
                                        <a href="/premium/" target="_blank">&nbsp;premium&nbsp;</a>
                                        version. In both the free and premium version, we have allow users to use just the user's
                                        hand, shared cards and the number of players to estimate the odds.
                                    </li>
                                    <li>
                                        <strong>Opponents' average win rate</strong>.
                                        This is calculated as: (1 - My Win Rate)/(Num of Players - 1)
                                    </li>
                                    <li>
                                        <strong>Hand Rank</strong>.
                                        We developed a
                                        <a href="/resources/poker-hand-rankings" target="_blank" className="inline" rel="noopener noreferrer nofollow">
                                        &nbsp;hand rank&nbsp;
                                        </a>
                                        system based on the hand's winning odds.
                                        Double aces would have the highest odds of winning and therefore it is
                                        on the rank 1 hand. The stronger the hand, the higher the rank.
                                    </li>
                                    <li>
                                        <strong>Top hands that you could lose to after flop</strong>.
                                        This feature helps you to understand the risk and also to exercise judgement
                                        on whether your opponents have those hands. This feature also help beginners
                                        to reduce bias when having good hands because you will be trained to always identify
                                        the cards that can beat yours.
                                    </li>
                                    <li>
                                        <strong>Recommended action</strong>.
                                        The recommended action is provided automatically based on your probability of winning. 
                                    </li>
                                    <li>
                                        <b>Optimal Bet Size</b>.
                                        Optimal Bet Size is based on: (1) the number of opponents that are still in the game, and (2) the odds of winning.
                                        The number of opponents that are still in the game is related to the pot odds. 
                                        You can view it as the reward-to-risk ratio:
                                        <br/>
                                        <br/>
                                        <i>Pot Odds &gt;= One round reward-to-risk ratio (==number of opponents still playing)</i>
                                        <br/>
                                        <br/>
                                        We chose not to use pot odds because it is hard to calculate in real life.
                                        But, the number of opponents who are still playing is something everyone can grasp immediately.
                                        Using the above formula, we know that the actual pot odds is always greater than the number of opponents still playing.
                                        Hence, the number of opponents still playing is somewhat like a lower limit for the pot odds, which is easy to figure out.
                                        <br/>
                                        <br/>
                                        So, depending on how many opponents are still in the game, you can quickly determine the (approximated) optimal bet size.
                                        <br/>
                                        <br/>
                                        Using the winning odds and the reward-to-risk ratio, we use the Kelly criterion to compute the optimal bet size.
                                    </li>
                                    <li>
                                        <b>Designed to be used real-time while playing online poker</b>.
                                        To make it usable in real-life game, we ensured that Edge.Poker
                                        is responsive and we tried hard to reduce the number of interactions
                                        to compute the final result.
                                    </li>
                                </ol>
                            </Col>

                            <Col xs="12" id="why" className="mt-3">
                                <h2 className="mb-3">Comparing Edge.Poker</h2>
                                <p>
                                    Here's a table that compares Edge.Poker calculator to the other calculators and analyzers:
                                </p>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Edge.Poker</th>
                                            <th>Other Calculators & Analyzers</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Only need hands, shared cards & number of players</td>
                                            <td>Yes</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>Speed of input</td>
                                            <td>Fast (under 15 seconds)</td>
                                            <td>Slow</td>
                                        </tr>
                                        <tr>
                                            <td>Usable while playing</td>
                                            <td>Yes</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>Mobile Friendly</td>
                                            <td>Yes</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>Hand Rank</td>
                                            <td>Yes</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>Top Opponent Hand Analysis</td>
                                            <td>Yes</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>Recommended action</td>
                                            <td>Yes</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>Optimal bet size</td>
                                            <td>Yes</td>
                                            <td>No</td>
                                        </tr>
                                        <tr>
                                            <td>Hand-range-based analysis</td>
                                            <td>Available in Premium</td>
                                            <td>Most don't have it</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>

                            <Col xs="12" id="when" className="mt-5">
                                <h2 className="mb-3">When to use Edge.Poker?</h2>
                                <p>
                                    Edge.Poker is best used during online Texas Hold'em poker cash game. 
                                </p>
                                <p>
                                    You can also use it for 
                                    tournament as well. However, tournament is heavily dependent
                                    on how good your luck is during the early phases. The more chips
                                    you rack up earlier, the more helpful Edge.Poker will be.
                                </p>
                                <p>
                                    We believe that consistently using Edge.Poker in every online game will
                                    help improve your performance the most.
                                </p>
                                <p>
                                    If you have not read our "How-to-Use" page, we highly suggest you to read it
                                    <Link to="/how-to-use">
                                        &nbsp;here
                                    </Link>.
                                </p>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="0" lg="2"/>
                </Row>
                
            </Layout>
        )
    }
}

export default About;